<template>
  <div>
    <div class="ai-cons" v-if="isShowMessageContent">
      <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
      <markdown-it-vue ref="textContent" class="ai-cons-html" :class="!open ? 'open' : 'close'" :content="messageContent"/>
      <div class="btm-txt-block">
        <div class="ai-tips">(仅供内部学习参考，不得对外宣传及使用)</div>
        <div class="btm-txt2" @click="open = !open">
          {{ !open ? '展开' : '收起' }}
          <img src="../../../assets/images/home/img14.png" class="icon-btm" :class="open ? 'rotate' : ''" alt="">
        </div>
      </div>
    </div>
    <div class="ai-cons" v-else-if="isShowMemberTip">
      <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
      <div class="ai-cons-html">依据您提出的问题，我们认为平台内如下内容会对您有帮助。</div>
    </div>
    <div class="ai-cons" v-else-if="summaryLoading">
      <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
      <div class="ai-cons-html">正在为您生成，请稍候...</div>
    </div>
    <div class="ai-cons" v-else-if="isOverTime">
      <div class="top">
        <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
        <img src="@/assets/images/refresh.png" alt="" class="refresh" v-if="userInfo.memberType === 1" @click.stop="$emit('handleRefersh', 3)">
      </div>
      <div class="ai-cons-html">超时,请重试...</div>
    </div>
    <div class="ai-cons" v-else>
      <div class="top">
        <img src="../../../assets/images/home/img12.png" class="tip-img1" alt="">
        <img src="@/assets/images/refresh.png" alt="" class="refresh" v-if="userInfo.memberType === 1" @click.stop="$emit('handleRefersh', 3)">
      </div>
      <div class="ai-cons-html">依据您提出的问题，站点暂时缺少该部分内容，请期待后续更新。</div>
    </div>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'

export default {
  props: ['messageContent', 'AIresult', 'userInfo', 'curTabType', 'isOverTime', 'summaryLoading'],
  components: {
    MarkdownItVue,
  },
  computed: {
    isShowMessageContent() {
      return this.messageContent && this.userInfo.memberType === 1
    },
    isShowMemberTip() {
      const tabTypeMap = {
        '1': 'articleResult',
        '2': 'courseResult',
        '3': 'caseResult'
      }

      const tabType = this.curTabType
      const resultField = tabTypeMap[tabType]

      // 默认情况处理
      if (!resultField) {
        return false
      }

      const aiResult = this.AIresult
      if (!aiResult) {
        return false
      }

      const resultArray = aiResult[resultField]
      const isMember = this.userInfo.memberType === 0

      const hasResultArray = Array.isArray(resultArray) && resultArray.length > 0

      return hasResultArray && isMember
    },
  },
  data() {
    return {
      open: false
    }
  },
}
</script>

<style scoped lang="less">
.ai-cons {
  display: flex;
  flex-direction: column;

  .top {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
}

.refresh {
  width: 20px;
  margin-left: 10px;
  cursor: pointer;
}

.tip-img1 {
  width: 70px;
  display: block;
}

.tip-img2 {
  width: 104px;
  display: block;
  margin-bottom: 8px;
}

.ai-cons-html {
  margin-bottom: 20px;
  // display: -webkit-box;
  // -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  line-height: 24px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  transition: max-height 0.5s ease;
  /* 添加过渡效果 */

  &.close {
    // -webkit-line-clamp: unset;
    /* 展开后不限制行数 */
    max-height: null;
  }

  &.open {
    // -webkit-line-clamp: 7;
    /* 展开后不限制行数 */
    max-height: 168px;
  }
}

.ai-tips {
  font-family: Source Han Sans CN, Source Han Sans CN;
  color: rgba(255, 38, 38, 0.84);
  font-size: 12px;
  line-height: 20px;
}

.btm-txt-block {
  display: flex;
  justify-content: space-between;
  // align-items: center;
  position: relative;
  top: -15px;

  .btm-txt2 {
    color: #EB1700;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    min-width: 40px;
    // align-items: center;

    .icon-btm {
      display: block;
      width: 12px;
      height: 7px;
      margin-left: 2px;
      position: relative;
      top: 6px;

      &.rotate {
        transform: rotate(180deg);
      }
    }
  }
}

</style>
<style>
.markdown-body ol,
.markdown-body ul {
  padding-left: 0;
}

.markdown-body {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
}

.markdown-body li > p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/IntelligentRes.vue